
export function initEmailComposerListeners(): void {
  $(document).off("click", ".email-composer-button").on("click", ".email-composer-button", function(e) {
    const $button = $(this)
    const propsectId = $button.data("prospect-id")
    const modal = $('#emailComposerModal')
    let $select = modal.find("#emailRecipient")
    $select.empty()

    $.ajax({
      url: "/bots_prospects/find_address_email",
      method: "GET",
      data: {
        prospect_id: propsectId
      },
      success: function(response){
        if (!response.best_email_address){
          alert("There is no available email.")
        }
        $select.append($('<option></option>').val(response.best_email_address.id).text(response.best_email_address.email_address  + " (Best email address)").prop('selected', true))
        response.address_emails.forEach(email => {
          const $option = $('<option></option>').val(email.id).text(email.email_address);
          $select.append($option);
        });
        modal.modal('show')
      },
      error: function(xhr) {
        console.error(xhr.responseText)
      }
    })
  });

  $('#emailComposerModal').on('shown.bs.modal', function () {
    $(this).off('click', '#sendEmailBtn').on('click', '#sendEmailBtn', function(e) {
      e.preventDefault()
      const form = document.getElementById("emailForm") as HTMLFormElement;
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }
      const $form = $("#emailForm");
      const $emailRecipient = $form.find('#emailRecipient');
      const $emailSubject =  $form.find('#emailSubject');
      const $emaiContent = $form.find('.summernote');
      const $button = $(this)
      $button.prop("disabled", true).val("Sending...")
      $.ajax({
        url: "/bots_prospects/send_email",
        method: "POST",
        data: {
          recipient: $emailRecipient.val(),
          subject: $emailSubject.val(),
          content: $emaiContent.summernote('code')
        },
        success: function(response){
          // $button.val("Sent!").removeClass("blue-btn").addClass("green-btn");
          $button.prop('disabled', false).val("Send Email")
          $emaiContent.summernote('code', '');
          $emailSubject.val('');
          $('#emailComposerModal').modal('hide');
          showAjaxFlash("Email sent successfully.")
        },
        error: function(xhr) {
          $button.val("Failed!").removeClass("blue-btn").addClass("red-btn");
          setTimeout(()=>{
            $button.prop('disabled', false).val("Send Email").addClass("blue-btn").removeClass("red-btn");;
          }, 3000)
        },
        complete: function() {
          
        }
      })
    });
  });

  $('#emailComposerModal').on('hidden.bs.modal', function () {
    $(this).find('.summernote').summernote('code', '');
    $(this).find('#emailSubject').val('');
  });  
}

function showAjaxFlash(message) {
  const html = `
    <div class="notification notice alert alert-success alert-dismissible fade show mt-3" role="alert">
      ${message}
      <button type="button" class="close" data-dismiss="alert">&times;</button>
    </div>
  `;

  $(".container-fluid .notification").remove();

  $(".container-fluid").append(html);
}